import { useEffect } from "react";

/**
 * Tiny redirector page so any link to `/login` immediately hands off to
 * the Emergent Google Auth URL with a properly built `?redirect=` param.
 *
 * Why a page (not just an onClick handler):
 * - QuotaBanner / PaywallModal can deep-link here with a simple <Link>.
 * - Bookmarkable / shareable URL for "log in" if we ever want to.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS.
 */
const Login = () => {
  useEffect(() => {
    const redirectUrl = window.location.origin + "/";
    window.location.replace(
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl)
    );
  }, []);

  return (
    <div
      data-testid="login-redirect"
      className="min-h-[60vh] flex items-center justify-center font-mono text-xs uppercase tracking-widest text-[#6C706D]"
    >
      Redirecting to sign in…
    </div>
  );
};

export default Login;
